import { render, staticRenderFns } from "./RegisterStudyNewVersion.vue?vue&type=template&id=b542c88c"
import script from "./RegisterStudyNewVersion.vue?vue&type=script&lang=js"
export * from "./RegisterStudyNewVersion.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegisterStudyNewVersion.vue?vue&type=style&index=1&id=b542c88c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports